import React from 'react';
import DatePicker from 'react-datepicker';
import { Calendar } from 'lucide-react';
import { FormGroup, FormLabel, FormHint, FormError } from './form-group';
import { Button } from './button';
import { cn } from 'src/lib/utils';

import '../UsageData/reactdatepicker.css';

const DatePickerField = React.forwardRef(function DatePickerField(
  {
    label,
    id,
    hint,
    error,
    value,
    onChange,
    placeholder = 'Select date',
    minDate,
    maxDate,
    disabled = false,
    dateFormat = 'dd/MM/yyyy',
    showMonthDropdown = true,
    showYearDropdown = true,
    isClearable = true,
    scrollableYearDropdown,
    yearDropdownItemNumber = 5,
    className,
    ...datePickerProps
  },
  ref,
) {
  const fieldId = id || `datepicker-${Math.random().toString(36).slice(2, 9)}`;
  const selectedDate = value ? (value instanceof Date ? value : new Date(value)) : null;

  return (
    <FormGroup className={cn(className)}>
      {label && <FormLabel htmlFor={fieldId}>{label}</FormLabel>}
      <label className='input-group date datepicker h-9' htmlFor={fieldId}>
        <DatePicker
          ref={ref}
          id={fieldId}
          selected={selectedDate}
          onChange={onChange}
          placeholderText={placeholder}
          minDate={minDate}
          maxDate={maxDate}
          disabled={disabled}
          dateFormat={dateFormat}
          showMonthDropdown={showMonthDropdown}
          showYearDropdown={showYearDropdown}
          isClearable={isClearable}
          scrollableYearDropdown={scrollableYearDropdown}
          yearDropdownItemNumber={yearDropdownItemNumber}
          popperPlacement='bottom-end'
          className='h-full w-full min-w-0 flex-1 border-0 bg-transparent px-3.5 py-0 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none disabled:cursor-not-allowed disabled:opacity-50'
          {...datePickerProps}
        />
        <span className='input-group-btn'>
          <Button type='button' variant='ghost' size='sm' className='pointer-events-none'>
            <Calendar size={16} strokeWidth={1.5} />
          </Button>
        </span>
      </label>
      {hint && !error && <FormHint>{hint}</FormHint>}
      {error && <FormError>{error}</FormError>}
    </FormGroup>
  );
});

export { DatePickerField };
